import {
    JWT_COOKIE_CONFIG,
    JWT_COOKIE_KEY,
    JWT_COOKIE_NEEDS_REFRESH_AT_KEY
} from '~/constants/cookies';

const ONE_HOUR = 3_540_000;

function useJwtCookies() {
    refreshCookie(JWT_COOKIE_KEY);
    refreshCookie(JWT_COOKIE_NEEDS_REFRESH_AT_KEY);

    const jwtTokenCookie = useCookie(JWT_COOKIE_KEY, JWT_COOKIE_CONFIG);

    const jwtTokenCookieNeedsRefreshAtCookie = useCookie(
        JWT_COOKIE_NEEDS_REFRESH_AT_KEY,
        JWT_COOKIE_CONFIG
    );

    const jwtTokenCookieNeedsRefresh = ref(false);

    const setCookies = (token: string) => {
        jwtTokenCookie.value = token;
        jwtTokenCookieNeedsRefreshAtCookie.value = ( Date.now() + ONE_HOUR ).toString(10);

        refreshCookie(JWT_COOKIE_KEY);
        refreshCookie(JWT_COOKIE_NEEDS_REFRESH_AT_KEY);
    };

    const unsetCookies = () => {
        jwtTokenCookie.value = null;
        jwtTokenCookieNeedsRefreshAtCookie.value = null;

        refreshCookie(JWT_COOKIE_KEY);
        refreshCookie(JWT_COOKIE_NEEDS_REFRESH_AT_KEY);
    };

    return {
        jwtTokenCookie,
        jwtTokenCookieNeedsRefresh,
        jwtTokenCookieNeedsRefreshAtCookie,
        setCookies,
        unsetCookies
    };
}

export default useJwtCookies;
